module.exports = __webpack_public_path__ + "media/images/gallery/1s-6179a52775695f4143c0267488d211c0.jpg";